/**
 * Alterar o KM da O.S. — regras de tela (puras).
 *
 * Quem decide é a API (`checkOdometerChange`): só admin, sempre com motivo.
 * Aqui só se avisa ANTES de enviar, para o admin não descobrir o erro pelo 422.
 */

/** O mesmo mínimo da API (`ODOMETER_REASON_MIN`). */
export const ODOMETER_REASON_MIN = 10;

/** Acima disto o salto merece uma segunda olhada — o mesmo teto do checklist. */
export const ODOMETER_JUMP_WARN_KM = 3000;

export function parseKm(texto: string): number | null {
  const digitos = texto.replace(/\D/g, "");
  return digitos ? Number(digitos) : null;
}

export function fmtKmInput(texto: string): string {
  const n = parseKm(texto);
  return n == null ? "" : n.toLocaleString("pt-BR");
}

export interface DicaKm {
  tom: "neutro" | "alerta";
  texto: string;
}

/** O que mostrar embaixo do campo enquanto o admin digita. */
export function dicaKm(atual: number | null, novo: number | null): DicaKm | null {
  if (novo == null) return null;
  if (atual == null) return { tom: "neutro", texto: "A O.S. ainda não tem KM." };
  const d = novo - atual;
  if (d === 0) return { tom: "neutro", texto: "Igual ao KM atual da O.S." };
  if (d < 0) {
    return {
      tom: "alerta",
      texto: `${d.toLocaleString("pt-BR")} km — menor que o atual. Se o odômetro foi trocado ou zerado, diga no motivo.`,
    };
  }
  if (d > ODOMETER_JUMP_WARN_KM) {
    return { tom: "alerta", texto: `+${d.toLocaleString("pt-BR")} km — salto grande, confira o número.` };
  }
  return { tom: "neutro", texto: `+${d.toLocaleString("pt-BR")} km em relação ao atual.` };
}

/** Erro que impede salvar, ou null. */
export function erroAlteracaoKm(atual: number | null, novo: number | null, motivo: string): string | null {
  if (novo == null) return "Informe o novo KM.";
  if (novo === atual) return "O KM é igual ao atual da O.S.";
  if (motivo.trim().length < ODOMETER_REASON_MIN) {
    return `Escreva o motivo da alteração (mínimo ${ODOMETER_REASON_MIN} caracteres).`;
  }
  return null;
}
